import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

// Modal Video 
import ModalVideo from 'react-modal-video'
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import SectionTitle from "../../components/Shared/section-title";

//Import Images
import laptop from "../../images/onepage/laptop.png";

class ModalVideoSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this);
    }

    openModal() {
        this.setState({ isOpen: true })
    }

    render() {
        return (
            <React.Fragment>
                <Container className="mt-60">
                    <Row>
                        <Col xs="12">
                        <SectionTitle title="Copy trading actions from any Telegram channel To Meta Trader 4 (MT4) with Telegram Trade Copier" highlight="TelegramTradeCopier" desc="is the world's first lifetime licensed telegram trade copier software for forex, crypto and commodity trading. Watch the video to understand how it works." isH1={true}/>

                            <div className="position-relative" style={{zIndex: "1"}} data-aos="zoom-in" data-aos-duration="1600">
                                <img src={laptop} className="rounded img-fluid mx-auto d-block" alt=""/>
                                <div className="play-icon">
                                    <Link id="concept-video-playBtn" to="#" onClick={this.openModal} className="play-btn video-play-icon">
                                        <i className="mdi mdi-play text-primary rounded-pill bg-white shadow"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='AFvRYhyA2Ig' onClose={() => this.setState({ isOpen: false })} />
                </Container>
            </React.Fragment>
        );
    }
}

export default ModalVideoSection;
